module.exports = __webpack_public_path__ + "img/m_direction-title.1e7b9424.png";